module.exports = __webpack_public_path__ + "static/media/icon_minigame.1c60ba7f.png";